import * as React from 'react';
import { SVGProps } from 'react';

const SvgSurfNurbs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='-20 -20 80 80'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M 33 5.498 L 32.308 5.496 C 29.777 5.488 27.296 5.479 24.914 5.672 L 8.914 5.672 C 8.532 3.861 6.924 2.5 5 2.5 C 2.792 2.5 1 4.292 1 6.5 C 1 8.708 2.792 10.5 5 10.5 C 6.929 10.5 8.541 9.131 8.917 7.313 L 17.477 7.313 C 15.617 8.094 13.877 9.206 12.292 10.792 C 6.944 16.142 6.968 23.266 6.996 30.808 L 6.998 31.5 L 6 31.5 C 5.448 31.5 5 31.948 5 32.5 L 5 36.5 C 5 37.052 5.448 37.5 6 37.5 L 10 37.5 C 10.552 37.5 11 37.052 11 36.5 L 11 32.5 C 11 31.948 10.552 31.5 10 31.5 L 8.998 31.5 L 8.996 30.8 C 8.968 23.376 8.946 16.966 13.706 12.206 C 18.466 7.446 24.876 7.472 32.3 7.496 L 33 7.498 L 33 8.5 C 33 9.052 33.448 9.5 34 9.5 L 38 9.5 C 38.552 9.5 39 9.052 39 8.5 L 39 4.5 C 39 3.948 38.552 3.5 38 3.5 L 34 3.5 C 33.448 3.5 33 3.948 33 4.5 L 33 5.498 Z'
      fill='#000'
    />
  </svg>
);

export default SvgSurfNurbs;
